import User from "users/entities/user/user";

export default class LoginAsUserAPIRequest {
  userId: string;

  constructor(user: User) {
    if (!user.id?.value) {
      throw new Error("User must have a valid Guid id to be spoofed");
    }
    this.userId = user.id.value;
  }
}
